<template>
    <!-- 各门店票核销统计－页面 -->
    <div>
        <content-view class=" ticket-count">
            <div v-if="shopId == -1" slot="header">
                <a-tabs :defaultActiveKey='key' :animated="false" @change="onTabChange" class="tradeRecord_tab">
                    <a-tab-pane v-for="item in tabListNoTitle" :tab="item.tab" :key="item.key"></a-tab-pane>
                </a-tabs>
            </div>
            <div class="wrap-container-in">
                <div>
                    <a-form :form="form" layout="inline" >
                        当前日期：
                        <a-form-item>
                            <a-date-picker @change="startDateChange" :allowClear="false" v-decorator="['startDate',{initialValue: $moment($moment().valueOf() - (89 * 86400000))}]" format="YYYY-MM-DD" />
                        </a-form-item>
                        <span class="mr16">至</span>
                        <a-form-item>
                            <a-date-picker :disabledDate="disabledDate" :allowClear="false" v-decorator="['endDate',{initialValue: $moment()}]" format="YYYY-MM-DD" />
                        </a-form-item>
                        <a-button type="primary" @click="getData">搜索</a-button>
                        <a-button type="primary" @click="exportExcel" :loading="exportLoading">导出</a-button>
                        <span class="text-fail ml16">(时间搜索范围跨度最大为：90天)</span>
                        <div class="float-right">
                            <a-button type="primary" @click="showAddSchemeModal">新增</a-button>
                            <a-button v-if="!canDetele" @click="deleteSellPlan">删除</a-button>
                            <a-button v-if="canDetele" type="primary" @click="cancelDelete">完成</a-button>
                        </div>
                    </a-form>
                </div>
                <a-divider></a-divider>
                <a-spin :spinning="schemeSpinning">
                    <div class="ticket-scheme-raido-container">
                        <div v-for="item in allSchemesList" :key="item.id">
                            <a-radio @click="onClickRideo(item.id)" :checked="item.checked" >{{item.schemeName}}</a-radio> <a-divider v-if="item.id" type="vertical" /> 
                            <a-popconfirm title="确定要删除该方案吗？" @confirm="delScheme(item.id)" okText="确定" cancelText="取消">
                                <a-icon v-if="canDetele && item.id" type="close-circle" style="color:#f31d2b" />
                            </a-popconfirm>
                            <a-icon v-if="!canDetele && item.id" type="edit" @click="getSchemeInfo(item.id)" />
                        </div>
                    </div>
                    <div class="text-center" v-if="allSchemesList.length === 0">暂无方案，请先进行方案新增</div>
                </a-spin>
                <a-divider></a-divider>
                <a-table :loading="loading" :scroll="{ x: columns.length*90}" :pagination="false" @change="changePage"
                :dataSource="dataSource" :columns="columns" :rowKey="(record,index) => index"
                :rowClassName="(record, index) => {
                    let className = 'light-row';
                    if (index % 2 === 1) className = 'dark-row';
                    return className;
                }"
                >
                    <span slot="braceletNo" slot-scope="braceletNo">{{braceletNo ? braceletNo : "-"}}</span>
                    <span slot="consumeTime" slot-scope="consumeTime">{{consumeTime ? consumeTime : "-"}}</span>
                    <span slot="shopName" slot-scope="shopName">{{shopName ? shopName : "-"}}</span>
                    <span slot="cashier" slot-scope="cashier">{{cashier ? cashier : "-"}}</span>
                </a-table>
                <div class="text-center" v-if="columns.length === 0">暂无数据，请先浏览其他页面～</div>
            </div>
            <!-- 新增方案弹窗 -->
            <a-modal 
            title="新增票券核销方案"
            :confirmLoading="addSchemeLoading"
            :visible="addSchemeVisible"
            :bodyStyle="{padding: 0, height: 800}"
            @cancel="hideAddSchemeModal"
            @ok="addScheme"
            :width="900"
            style="height: 800px"
            >   
                <a-spin :spinning="ticketListSpinning">
                    <a-form :form="addSchemeForm" :selfUpdate="true">
                        <a-tabs defaultActiveKey='0'>
                            <a-tab-pane tab="上架中票券" key="0" :forceRender="true">
                                <a-form-item label="方案名称" :labelCol="{span: 3}" :wrapperCol="{span: 8}">
                                    <a-input v-decorator="['name',{rules: [{required: true, message: '请输入'},{max: 15, message: '最多15个字符'}]}]" placeholder="请输入" />
                                </a-form-item>
                                <a-form-item label="票券" :labelCol="{span: 3}" :wrapperCol="{span: 20}">
                                    <div class="select-ticket-container">
                                        <a-checkbox-group :options="ticketList.up" v-decorator="['onlineIds[0]',{initialValue: []}]" />
                                    </div>
                                </a-form-item>
                            </a-tab-pane>
                            <a-tab-pane tab="已下架/删除票券" key="1" :forceRender="true">
                                <a-form-item label="票券" :labelCol="{span: 3}" :wrapperCol="{span: 20}">
                                    <div class="select-ticket-container">
                                        <a-checkbox-group :options="ticketList.offdel" v-decorator="['onlineIds[1]',{initialValue: []}]" />
                                    </div>
                                </a-form-item>
                            </a-tab-pane>
                        </a-tabs>
                    </a-form>
                </a-spin>
            </a-modal>
        </content-view>
    </div>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex";
export default {
    name: "statementPage1",
    components: {},
    props: {},
    data() {
        return {
            columns: [],
            dataSource: [],
            tabListNoTitle: [],
            pagination: {
                showTotal: total => `共 ${total} 条数据`,
                showSizeChanger: true,
                showQuickJumper: true,
                total: 0,
                current: 1,
                pageSize: 20
            },
            loading: false,
            key: undefined,
            name: '',
            addSchemeVisible: false,
            ticketList:  {
                shelvesTicketList: {
                    up: [],
                    offdel: []
                },
            },
            exportLoading: false,
            schemeSpinning: false,
            ticketListSpinning: false,
            addSchemeLoading: false,
            schemeId: undefined,
            activeSchemeId: undefined,
            allSchemesList: [],
            canDetele: false,
            isSchemeEdit: false
        };
    },
    computed: {
        ...mapGetters(["shopId"])
    },
    methods: {
        /**
         * @startDateChange 开始日期变动联动结束日期
         */
        startDateChange(date) {
            this.form.setFieldsValue({'endDate': this.$moment(date.valueOf() + (89 * 86400000))});
        },
        /**
         * @disabledDate 结束日期的禁用
         */
        disabledDate(date) {
            let startDate = this.form.getFieldValue('startDate');
            return !(date.valueOf() >= startDate.valueOf() && ((date.valueOf() - startDate.valueOf()) < (90 * 86400000)))
        },
        /**
         * @showAddSchemeModal 显示新增方案弹窗
         */
        showAddSchemeModal() {
            this.addSchemeVisible = true;
            this.isSchemeEdit = false;
        },
        /**
         * @hideAddSchemeModal 隐藏新增方案弹窗
         */
        hideAddSchemeModal() {
            this.addSchemeForm.setFieldsValue({
                name: undefined,
                onlineIds: [[], []],
            });
            this.addSchemeVisible = false;
        },
        changePage(page) {
            this.pagination.pageSize = page.pageSize
            this.pagination.current = page.current
            this.getData()
        },
        getShopList() {
            if(!this.shopId) return
            this.$api.totalPlatform.selectList()
            .then(res => {
                this.tabListNoTitle = []
                if(this.shopId == -1) {
                    res.map(item => {
                        this.tabListNoTitle.push({
                            key: item.id,
                            tab: item.name
                        })
                    })
                }else {
                    this.tabListNoTitle.push({
                        key: this.shopId,
                        tab: res.filter(item => item.id == this.shopId)[0].name
                    })
                }
                
                this.key = String(this.tabListNoTitle[0].key);
                this.name = String(this.tabListNoTitle[0].tab);
                this.getTicketList();
                this.queryAllSchemes();
            });
        },
        /**
         * @getTicketList 门店线上线下票
         */
        getTicketList() {
            this.ticketListSpinning = true;
            this.$api.statement.queryTicketByShopId({
                params: {
                    shopId: this.key
                }
            }).then(res => {
                res.up.forEach(item => {
                    item.label = item.name;
                    item.value = item.ticketTemplateId;
                });
                res.offdel.forEach(item => {
                    item.label = item.name;
                    item.value = item.ticketTemplateId;
                });
                this.ticketList = res;
                this.ticketListSpinning = false;
            });
        },
        /**
         * @queryAllSchemes 查询方案
         */
        queryAllSchemes() {
            this.schemeSpinning = true;
            this.$api.statement.queryAllSchemes({
                params: {
                    shopId: this.key
                }
            }).then(res => {
                res.forEach(item => {
                    item.checked = false;
                })
                if(res.length >= 1) {
                    res[0].checked = true;
                    this.schemeId = res[0].id;
                } else {
                    this.schemeId = 0;
                }
                this.allSchemesList = res;
                this.schemeSpinning = false;
                this.getData();
            });
        },
        /**
         * @getDate 获取报表数据
         */
        getData() {
            this.form.validateFields((errors,values) => {
                if (errors) return;
                this.loading = true
                this.$api.statement.ticketVerifyTotal({params:{
                    shopId: this.key,
                    pageNum: this.pagination.current,
                    pageSize: 99999999,
                    schemeId: this.schemeId,
                    startDate: values.startDate.format('YYYY-MM-DD'),
                    endDate: values.endDate.format('YYYY-MM-DD')
                }})
                .then(res => {
                    this.loading = false
                    this.columns = []
                    this.dataSource = []
                    let title = res[0].data
                    let sumArray = [];
                    for(let i in res) {
                        if(i > 0) {
                            this.dataSource.push({...res[i].data})
                        }
                    }
                    res[0].data.forEach((item,index,array) => {
                        // 表头
                        this.columns.push({
                            title: title[index],
                            dataIndex: index,
                            sorter: index == 0 && ((a, b) => this.$moment(a['0']) - this.$moment(b['0'])),
                            sortOrder: index == 0 && 'descend'
                        })
                        // 求和
                        sumArray.push(res.reduce(function(pre, item, innerIndex, array) {
                            if (innerIndex > 0 && index > 0) {
                                return pre + Number(item.data[index])
                            } else {
                                return 0
                            }
                        }, 0));
                    });
                    sumArray = {...sumArray}
                    sumArray['0'] = '合计'
                    this.dataSource.unshift(sumArray)
                    this.pagination.total = res.total
                }).catch(err => {
                    this.columns = [];
                    this.dataSource = [];
                    this.loading = false
                })
            });
        },
        // 导出excel
        exportExcel() {
            this.form.validateFields((errors,values) => {
                if (errors) return;
                this.exportLoading = true;
                this.$api.statement
                .exportExcel({
                    params: {   
                        pageNum: 1,
                        pageSize: 99999999,
                        shopId: this.key,
                        schemeId: this.schemeId,
                        startDate: values.startDate.format('YYYY-MM-DD'),
                        endDate: values.endDate.format('YYYY-MM-DD')
                    }
                },
                {
                    responseType: "blob"
                })
                .then(res => {
                    let a = document.createElement("a");
                    let blob = new Blob([res.data], {
                        type: "application/vnd.ms-excel"
                    });

                    this.downloadUrl = window.URL.createObjectURL(blob);

                    let name = this.name + '-' + this.$moment().format('YYYY/MM/DD') + '.xls'

                    a.setAttribute("href", this.downloadUrl);

                    var reportName = decodeURI(name);

                    a.setAttribute("download", reportName);
                    a.click();
                    this.exportLoading = false

                }).catch(err => {
                    this.exportLoading = false
                })
            })
        },
        onTabChange(e) {
            this.key = e
            this.name = this.tabListNoTitle.filter(item => item.key === e)[0].tab
            this.getTicketList();
            this.queryAllSchemes();
        },
        /**
         * @addScheme 新增/编辑方案
         */
        addScheme(){
            this.addSchemeForm.validateFields((errors, values) => {
                if(errors) {
                    return false;
                }
                if (!values.onlineIds.flat().length) {
                    this.$message.error('票券不能为空');
                    return false;
                }
                this.addSchemeLoading = true;
                let reqData = {
                    shopId: this.key,
                    schemeName: values.name,
                    ticketIds: values.onlineIds.flat(),
                };
                if (this.isSchemeEdit) {
                    reqData.schemeId = this.activeSchemeId;
                }
                this.$api.statement[this.isSchemeEdit ? 'editScheme' : 'saveScheme'](
                    {
                        body: reqData
                    }
                ).then(res => {
                    this.addSchemeLoading = false;
                    this.$message.success('操作成功！');
                    this.hideAddSchemeModal();
                    this.queryAllSchemes();
                }).catch(error => {
                    this.addSchemeLoading = false;
                });
            });
        },
        /**
         * @delScheme 删除方案
         */
        delScheme(schemeId){
            this.$api.statement.delScheme({
                params: {
                    schemeId
                }
            }).then(res => {
                this.$message.success('删除成功！');
                this.queryAllSchemes();
            });
        },
        /**
         * @getSchemeInfo 获取方案详情
         */
        getSchemeInfo(schemeId) {
            this.activeSchemeId = schemeId;
            this.addSchemeVisible = true;
            this.ticketListSpinning = true;
            this.isSchemeEdit = true;
            this.$api.statement.schemeInfo({
                params: {
                    schemeId
                }
            }).then(res => {
                /**
                 * @offlineIdsArray 详情结果票券id数组
                 * @onlineIdsArray 详情结果票券id数组
                 * @sOnlineTickets 正在售卖的线上票列表
                 * @sOfflineTickets 正在售卖的线下票列表
                 * @sOnlineIds 方案详情正在售卖的线上票券id
                 * @sOfflineIds 方案详情正在售卖的线下票券id
                 * @wOnlineIds 方案详情已下架/删除的线上票券id
                 * @wOfflineIds 方案详情已下架/删除的线下票券id
                 */
                let onlineIdsArray = res.ticketId.split(',');
                let sOnlineTickets = this.ticketList.up;
                let sOfflineTickets = this.ticketList.offdel;
                let sOnlineIds = [];
                let wOnlineIds = [];
                // 线上在售票券筛选
                sOnlineTickets.forEach(items => {
                    let findRes = onlineIdsArray.find(item => item === items.ticketTemplateId);
                    if (typeof findRes !== 'undefined') {
                        sOnlineIds.push(findRes);
                    }
                });
                sOfflineTickets.forEach(items => {
                    let findRes = onlineIdsArray.find(item => item === items.ticketTemplateId);
                    if (typeof findRes !== 'undefined') {
                        wOnlineIds.push(findRes);
                    }
                });
                setTimeout(() => {
                    this.ticketListSpinning = false;
                    this.addSchemeForm.setFieldsValue({
                        name: res.schemeName,
                        onlineIds: [sOnlineIds, wOnlineIds],
                    });
                },300)
            });
        },
        /**
         * @deleteSellPlan 删除按钮
         */
        deleteSellPlan() {
            this.canDetele = true;
        },
        /**
         * @cancelDelete 删除完成按钮
         */
        cancelDelete() {
            this.canDetele = false;
            this.queryAllSchemes();
        },
        /**
         * @onClickRideo 方案radio的点击事件
         */
        onClickRideo(id) {
            this.schemeId = id
            this.getData()
            this.allSchemesList.forEach(item => {
                item.checked = false
                if(item.id === id) {
                    item.checked = true
                }
            })
        }
    },
    beforeCreate() {
        this.form = this.$form.createForm(this);
        this.addSchemeForm = this.$form.createForm(this);
    },
    created() {},
    mounted() {
        this.getShopList()
    },
    watch: {
        'shopId'() {
            this.getShopList()
        }
    }
};
</script>
<style lang="scss">
.ticket-count {
    .wrap-title {
        padding-bottom: 8px;
    }
    .wrap-header {
        padding-bottom: 0;
    }
    .wrap-container-in {
        padding: 16px;
    }
    .ant-table-thead > tr > th, .ant-table-tbody > tr > td {
        padding: 6px;
    }
    .dark-row {
        background-color: #f9f9f9;
    }
    table td,
    table th {
        text-align: center;
    }
    .ant-table-column-sorter {
        display: none;
    }
    .ticket-scheme-raido-container {
        >div {
            display: inline-block;
            margin: 0 8px 8px 0;
            padding: 4px 12px;
            border: 1px solid #e9e9e9;
            border-radius: 4px;
            &:hover {
                border: 1px solid #ff9646;
            }
        }
    }
}
.select-ticket-container {
    max-height: 200px;
    overflow-x: hidden;
    overflow-y: scroll;
}
</style>